import { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../assets/logo-evar.jpg';
import { useCatalog } from '../../data/useCatalog';
import { usePayment } from '../../data/usePayment';
import { waLink } from '../../data/store';
import './Footer.css';

const INSTAGRAM_LINK = { label: 'Instagram', href: 'https://www.instagram.com/evar.stores' };

const LOCATION_LINKS = [
  { label: 'Mahalla', href: 'https://maps.app.goo.gl/qdEaXK5429aAKvct5?g_st=ic' },
  { label: 'Samanoud', href: 'https://maps.app.goo.gl/SZmjFMd7uWioSpSSA?g_st=ic' },
];

function Footer({ onSelectCategory }) {
  const navigate = useNavigate();
  const { categories } = useCatalog();
  const { whatsapp } = usePayment();
  const { pathname } = useLocation();
  const pendingCategoryScroll = useRef(false);

  useEffect(() => {
    if (!pendingCategoryScroll.current || pathname !== '/') return undefined;
    const timer = setTimeout(() => {
      document.getElementById('shop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      pendingCategoryScroll.current = false;
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname]);

  function selectCategory(event, filter) {
    event.preventDefault();
    onSelectCategory?.(filter);
    if (pathname === '/') {
      document.getElementById('shop')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }
    pendingCategoryScroll.current = true;
    navigate('/');
  }

  const columns = [
    { title: 'Categories', items: categories.map((category) => ({ label: category.title, filter: category.id })) },
    {
      title: 'Contact',
      items: [
        ...(whatsapp ? [{ label: 'WhatsApp', href: waLink(whatsapp) }] : []),
        INSTAGRAM_LINK,
      ],
    },
    { title: 'Our Locations', items: LOCATION_LINKS },
  ];

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__brand">
          <img className="footer__logo" src={logo} alt="EVAR" width="132" height="40" />
          <p className="footer__tagline">
            EVAR — <br></br>
            Beyond Trends. Above Ordinary.
          </p>
        </div>

        <div className="footer__columns">
          {columns.map((column) => (
            <nav className="footer__column" key={column.title} aria-label={column.title}>
              <h3 className="footer__column-title">{column.title}</h3>
              <ul>
                {column.items.map((item) => (
                  <li key={item.label}>
                    {item.filter ? (
                      <a href="#shop" onClick={(event) => selectCategory(event, item.filter)}>{item.label}</a>
                    ) : (
                      <a href={item.href} target="_blank" rel="noreferrer">{item.label}</a>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} EVAR. All rights reserved.</span>
      </div>
    </footer>
  );
}

export default Footer;
